<div class="dz-hidden-lg padding-10">
	<dz-select [value]="selectedOption" (valueChange)="optionClickHandler($event)">
		<dz-option *ngFor="let option of homePageLeftNav[selectedExploreCard]" [value]="option">
			<div [dcrHTMLKey]="option + '_HEADER'">{{ option | dcrKey }}_HEADER</div>
		</dz-option>
	</dz-select>
</div>

<div class="dz-grid dz-hidden dz-block-lg">
	<div class="dz-row">
		<div dcrHTMLKey="HOME_PAGE_LEFT_NAV_HEADER" class="text-20-bold nav-header">Tailor your approach</div>
	</div>
	<ng-container *ngFor="let option of homePageLeftNav[selectedExploreCard]">
		<div class="dz-row option-container" (click)="optionClickHandler(option)" [class.active]="selectedOption === option">
			<div [dcrHTMLKey]="option + '_HEADER'" class="text-16-bold">{{ option | dcrKey }}_HEADER</div>
			<div [dcrHTMLKey]="option + '_SUB_HEADER'" class="text-14">{{ option | dcrKey }}_SUB_HEADER</div>
		</div>
	</ng-container>
</div>
